export default __webpack_public_path__ + "02cfa4aba060d7a322af99c6ff3b2e2f.png";